// extracted by mini-css-extract-plugin
module.exports = {"empty":"BecomeSpeaker_empty__MBxL4","appearance":"BecomeSpeaker_appearance__3dJJ9","disappearance":"BecomeSpeaker_disappearance__Uy4o6"};